<!--
  Generated template for the ContactDetailsPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->
<ion-header *ngIf="showHeader">

    <ion-toolbar>
        <ion-title>{{'Contacts' | translate}}</ion-title>
    </ion-toolbar>

</ion-header>


<div class="main">
    <ion-row>
        <ion-col>
            <app-contact-data (selectedRow)="contactSelect($event)" [contractData]="patientDataProvider.activePatientData.contacts"
                          [isEdit]="false"></app-contact-data>
        </ion-col>
    </ion-row>
    <ion-row>
        <ion-col size="12" sizeLg="6">
            <app-phone-data (selectedRow)="setPhoneContact($event)" [addressData]="selectedContact"
                        [isEdit]="false" [phoneData]="selectedContact.contactNumbers || []"></app-phone-data>
        </ion-col>
        <ion-col size="12" sizeLg="6">
            <contact-address [contractData]="selectedContact" [isEdit]="false"></contact-address>
        </ion-col>
    </ion-row>
</div>
